import React from 'react';

import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import { alpha } from '@mui/material/styles';

export const LgTabs = ({ tab, config, handleTabChange, sx }) => {
    return (
        <Grid item xs={2}>
            <Tabs
                orientation='vertical'
                value={tab}
                onChange={handleTabChange}
                sx={{
                    minHeight: '100%',
                    borderRight: (theme) => `solid 1px ${theme.palette.divider}`
                }}
            >
                {config.map((item, index) => (
                    <Tab
                        key={index}
                        label={item.label}
                        sx={{
                            textAlign: 'left',
                            borderRadius: '8px 0 0 8px',
                            backgroundColor: tab === index ? (theme) => alpha(theme.palette.primary.main, 0.08) : 'inherit',
                            ':hover': {
                                backgroundColor: tab === index ? (theme) => alpha(theme.palette.primary.main, 0.16) : 'rgba(145, 158, 171, 0.08)'
                            },
                            ...sx
                        }}
                    />
                ))}
            </Tabs>
        </Grid>
    );
}

export const SmTabs = ({ tab, config, handleTabChange, sx }) => {
    return (
        <Grid item xs={12}>
            <Tabs
                orientation='horizontal'
                value={tab}
                onChange={handleTabChange}
                sx={{
                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                    ...sx
                }}
            >
                {config.map((item, index) => (
                    <Tab
                        key={index}
                        label={item.label}
                        sx={{
                            display: 'flex !important',
                            alignItems: 'center !important',
                            flexWrap: 'wrap !important'
                        }}
                    />
                ))}
            </Tabs>
        </Grid>
    );
}